import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M1.25 17h3.5a.25.25 0 0 0 .25-.25v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a.25.25 0 0 0 .25.25M8 8.75a1 1 0 0 0-1 1v7a.25.25 0 0 0 .25.25h3.5a.25.25 0 0 0 .25-.25v-7a1 1 0 0 0-1-1Zm6 2a1 1 0 0 0-1 1v5a.25.25 0 0 0 .25.25h3.5a.25.25 0 0 0 .25-.25v-5a1 1 0 0 0-1-1ZM19.25 17h3.5a.25.25 0 0 0 .25-.25v-12a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12a.25.25 0 0 0 .25.25M1 20.25h22a1 1 0 0 0 1-1 1 1 0 0 0-.56-.9 1.05 1.05 0 0 0-.44-.1H1a1.05 1.05 0 0 0-.44.1 1 1 0 0 0-.56.9 1 1 0 0 0 1 1"
    }, null, -1)
  ]));
}
const moneyGraphBarChartIncrease = { render };
export {
  moneyGraphBarChartIncrease as default,
  render
};
//# sourceMappingURL=money-graph-bar-chart-increase.svg.js.map
